module.exports = __webpack_public_path__ + "img/logo-app.ed55d1f1.png";